import tw from "twin.macro";
import { CircularProgress } from "@mui/material";

const CircularProgressMidParent = tw(CircularProgress)`absolute left[50%] top[50%] transform[translate(-50%, -50%)]`;
export default CircularProgressMidParent;
